import { Component } from '@angular/core';
import {PhysicalCard} from './physical-card.model';

@Component({
  selector: 'app-detail-table',
  templateUrl: './physical-card-table.component.html',
  styleUrls: ['../../../detail-screen/detail-screen.component.css'],
})
export class PhysicalCardTableComponent {
  restrictedData: boolean;
  tableColumns: string[];
  tableData: PhysicalCard[];
  emptyValuePlaceholder = '-';
  errorText: string;
  showTable: boolean;

  constructor() {
    this.tableColumns = [];
    this.tableData = [];
  }

  public formatBlocksDate(date): string {
    if (date.blocks != null && date.blocks.length) {
      return date.blocks[0].startDate;
    }
    return '-';
  }

  public isRemovable(data): string {
    if (data.blocks != null && data.blocks.length > 0) {
      return data.blocks[0].removable ? 'Ja' : 'Nee';
    }

    return '-';
  }
}
